import * as React from 'react';
import "./TextareaElement.scss";
import { ChangeEvent, useEffect, useMemo, useState } from 'react';
import { TextareaDefines, TextareaProps } from './ITextarea';
import InputElement from '../core/InputElement';
import { ElementType } from '../../common/enum/elementType';
import useActionExecutor from '../service/actionExecutor';
import { ColorDefines } from '../../interface/IColors';
import { replaceStringValue } from '../../util/replaceStringValue';

interface TextareaElementProps {
  props: TextareaProps;
  defines: TextareaDefines;
  colors: ColorDefines;
}

const TextareaElement = ({ props, defines, colors }: TextareaElementProps) => {
  const [touched, setTouched] = useState(false);
  // console.debug(props.getData().data.input)
  const [value, setValue] = useState(props.value || (
    typeof defines.defaultValue === "function"
      ? (() => {
        try {
          return defines.defaultValue(props.getData().data.input);
        } catch (e) {
          console.error(e)
          return "";
        }
      })()
      : replaceStringValue(defines.defaultValue as string, props.getData().data.input)
  ))
  const { click, change } = useActionExecutor(props.event, defines, (v: any) => {
    if (typeof v === "string") setValue(v);
  });

  useEffect(() => {
    if (!defines.readonly) return;
    setValue(
      typeof defines.defaultValue === "function"
        ? (() => {
          try {
            return defines.defaultValue(props.getData().data.input);
          } catch (e) {
            console.error(e)
            return "";
          }
        })()
        : replaceStringValue(defines.defaultValue as string, props.getData().data.input)
    )
  }, [props.visible]);

  const setTouchedWrapper = (v: boolean) => {
    setTouched(v);
    if (props.setTouched) props.setTouched(v);
  }

  const onchange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setTouchedWrapper(true);
    const v = e.target?.value;
    if (defines.readonly) return;
    setValue(v);
    if (change) change(e);
  }
  
  return (
    <InputElement
      type={ElementType.TEXTAREA}
      value={value}
      touched={touched}
      dispatchValid={props.dispatchValid}
      {...{ props, defines }}
    >
      <textarea
        name={defines.name}
        rows={defines.rows}
        placeholder={defines.placeholder}
        readOnly={!!defines.readonly}
        value={typeof value === "string" ? value : ""}
        onBlur={_ => setTouchedWrapper(true)}
        onChange={onchange}>
        {props.value}
      </textarea>
    </InputElement>
  );
}

export default TextareaElement;